import software from '../Images/software.png';
import stagexafrica from '../Images/stagexafrica.PNG';
import nomad from '../Images/nomad.png';
import nextgen from '../Images/nextgen.png';
import travel from '../Images/travel.png';
import werkling from '../Images/werkling.png';

export const projects = [
  {
    id: 1,
    name: 'StagexAfrica',
    category: 'Web Development',
    client: 'Stagex Africa Limited',
    duration: '2 months',
    teamSize: 'Solo Developer',
    technologies: ['Next.js', 'Node.js', 'Tailwind CSS', 'EmailJS', 'Responsive Design'],
    challenges: 'Complex timber industry requirements, real-time inventory management, multi-user roles',
    solutions: 'Custom CMS with role-based access, real-time inventory tracking, responsive design, SEO optimization',
    results: '40% increase in online inquiries, 25% improvement in user engagement, 60% reduction in order processing time',
    description: 'Stagex Africa Limited is a premier sawmill and wood products company based in Kenya, specializing in the supply and value addition of high-quality Cypress, Mahogany, Oak, and Eucalyptus timber.',
    liveDemo: 'https://stagexafrica.vercel.app/',
    github: 'https://github.com/GriffinsNgeno/stagexafrica',
    status: 'Completed',
    featured: true,
    coverimg: stagexafrica,
    img1: stagexafrica,
    metrics: [
      { value: '+40%', label: 'Online inquiries' },
      { value: '+25%', label: 'User engagement' },
      { value: '-60%', label: 'Order processing time' },
    ],
  },
  {
    id: 2,
    name: 'Digital Nomad Job Platform',
    category: 'Web Development',
    client: 'Personal Project',
    duration: '2.5 months',
    teamSize: 'Solo Developer',
    technologies: ['Bubble.io', 'JavaScript', 'API Integration', 'Responsive Design'],
    challenges: 'Complex job matching algorithms, user authentication, real-time notifications',
    solutions: 'No-code platform with custom workflows, automated job matching, real-time alerts',
    results: '500+ job postings, 200+ registered users, 85% user satisfaction rate',
    description: 'A comprehensive job listing platform built with Bubble.io that connects employers with job seekers.',
    liveDemo: 'https://digital-nomad-96116.bubbleapps.io/version-test/',
    github: '',
    status: 'Completed',
    featured: false,
    coverimg: nomad,
    img1: nomad,
    metrics: [
      { value: '500+', label: 'Job postings' },
      { value: '200+', label: 'Registered users' },
      { value: '85%', label: 'Satisfaction rate' },
    ],
  },
  {
    id: 3,
    name: 'NextGen Electronics E-commerce',
    category: 'E-commerce',
    client: 'NextGen Electronics',
    duration: '4 months',
    teamSize: '3 Developers',
    technologies: ['Bubble.io', 'Stripe API', 'JavaScript', 'Responsive Design'],
    challenges: 'Complex product catalog management, secure payment processing, inventory tracking',
    solutions: 'Full-featured e-commerce platform with admin dashboard, secure payment gateway, order tracking',
    results: '300+ products listed, 150+ successful transactions, 40% increase in online sales',
    description: 'A comprehensive e-commerce platform designed to enable businesses to sell electronics online.',
    liveDemo: 'https://nexgenelec254.bubbleapps.io/version-test/',
    github: '',
    status: 'Completed',
    featured: true,
    coverimg: nextgen,
    img1: nextgen,
    metrics: [
      { value: '300+', label: 'Products listed' },
      { value: '150+', label: 'Transactions' },
      { value: '+40%', label: 'Online sales' },
    ],
  },
  {
    id: 4,
    name: 'Werkling Startup',
    category: 'Web Development',
    client: 'Werkling Australia',
    duration: '3 months',
    teamSize: '4 Developers',
    technologies: ['Bubble.io', 'JavaScript', 'API Integration', 'Responsive Design'],
    challenges: 'Complex startup requirements, rapid development, scalable architecture',
    solutions: 'Collaborative development, modular architecture, agile methodology',
    results: 'Successful startup launch, scalable platform ready for growth',
    description: 'A scalable, two-sided platform connecting businesses with vetted freelance professionals.',
    liveDemo: 'https://werkling.com/',
    github: '',
    status: 'Completed',
    featured: false,
    coverimg: werkling,
    img1: werkling,
    metrics: [
      { value: '2-sided', label: 'Marketplace' },
      { value: 'Live', label: 'Production' },
      { value: '4 devs', label: 'Team size' },
    ],
  },
  {
    id: 5,
    name: 'Travel XP',
    category: 'Web Development',
    client: 'Travel XP America',
    duration: '3 months',
    teamSize: '2 Developers',
    technologies: ['Bubble.io', 'JavaScript', 'API Integration', 'Responsive Design'],
    challenges: 'Immersive travel content, community engagement, mobile-first design',
    solutions: 'Discovery, storytelling, and community features in one platform',
    results: 'Successful launch with positive user engagement',
    description: 'An immersive mobile and web platform that transforms travel experiences into shareable content.',
    liveDemo: 'https://travelxpapp.com/',
    github: '',
    status: 'Completed',
    featured: false,
    coverimg: travel,
    img1: travel,
    metrics: [
      { value: 'Mobile', label: 'First design' },
      { value: 'Live', label: 'Production' },
      { value: '2 devs', label: 'Team size' },
    ],
  },
  {
    id: 6,
    name: 'wHTa Networks',
    category: 'Web Development',
    client: 'wHTa Networks',
    duration: '2.5 months',
    teamSize: '3 Developers',
    technologies: ['React.js', 'Node.js', 'MongoDB', 'Tailwind CSS'],
    challenges: 'Complex startup requirements, rapid development, scalable architecture',
    solutions: 'Collaborative development, modular architecture, version control',
    results: 'Successful startup launch, scalable platform ready for growth',
    description: 'An innovative startup company website built with a collaborative team of developers.',
    liveDemo: 'https://whtanetworks.com/',
    github: '',
    status: 'Completed',
    featured: false,
    coverimg: software,
    img1: software,
    metrics: [
      { value: 'React', label: 'Frontend' },
      { value: 'Live', label: 'Production' },
      { value: '3 devs', label: 'Team size' },
    ],
  },
];

export const featuredProjects = projects.filter((p) => p.featured);

export const impactOutcomes = [
  {
    id: 1,
    project: 'StagexAfrica',
    client: 'Stagex Africa Limited',
    category: 'Web Development',
    duration: '2 months',
    highlight: '40% increase in online inquiries after launching the new platform',
    metrics: ['+40% inquiries', '+25% engagement', '-60% processing time'],
    liveDemo: 'https://stagexafrica.vercel.app/',
  },
  {
    id: 2,
    project: 'NextGen Electronics',
    client: 'NextGen Electronics',
    category: 'E-commerce',
    duration: '4 months',
    highlight: '40% increase in online sales with 150+ successful transactions',
    metrics: ['+40% sales', '300+ products', '95% payment success'],
    liveDemo: 'https://nexgenelec254.bubbleapps.io/version-test/',
  },
  {
    id: 3,
    project: 'Digital Nomad Platform',
    client: 'Personal Project',
    category: 'Web Development',
    duration: '2.5 months',
    highlight: '500+ job postings and 200+ registered users on launch',
    metrics: ['500+ jobs', '200+ users', '85% satisfaction'],
    liveDemo: 'https://digital-nomad-96116.bubbleapps.io/version-test/',
  },
  {
    id: 4,
    project: 'Werkling',
    client: 'Werkling Australia',
    category: 'Startup Platform',
    duration: '3 months',
    highlight: 'Two-sided marketplace launched and scaled with a 4-person dev team',
    metrics: ['Live product', 'Scalable', '4 developers'],
    liveDemo: 'https://werkling.com/',
  },
  {
    id: 5,
    project: 'Travel XP',
    client: 'Travel XP America',
    category: 'Mobile & Web',
    duration: '3 months',
    highlight: 'Immersive travel platform combining discovery, storytelling, and community',
    metrics: ['Mobile-first', 'Live product', '2 developers'],
    liveDemo: 'https://travelxpapp.com/',
  },
  {
    id: 6,
    project: 'wHTa Networks',
    client: 'wHTa Networks',
    category: 'Startup Website',
    duration: '2.5 months',
    highlight: 'Modern startup website built with React, Node.js, and MongoDB',
    metrics: ['React stack', 'Live product', '3 developers'],
    liveDemo: 'https://whtanetworks.com/',
  },
];